
export enum DocumentUploadViewModeEnum {
    PLUS_BUTTON = 'fa-plus',
    LABEL_BUTTON = '',
    FLASK_ICON = 'fa-flask', // Celebrating the first CF AI Hackaton
}